import { render, staticRenderFns } from "./PersonalIdForm.vue?vue&type=template&id=62f7d8ea&scoped=true&"
import script from "./PersonalIdForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalIdForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalIdForm.vue?vue&type=style&index=0&id=62f7d8ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7d8ea",
  null
  
)

export default component.exports